<template>
  <div class="page-container">
    <div class="page-header">
      <div class="d-flex align-items-center w-100">
        <b-button variant="link" class="mr-3" @click="onBack()">
          <v-icon name="buttons/chevrons_left" :size="13"/>
        </b-button>

        <h4 v-if="isBusy" id="user-ellipsis-loading">Загрузка пользователя</h4>
        <h4 v-else>{{ user.name ? user.name : "Новый пользователь" }}</h4>

        <span v-if="!isBusy" :class="['custom-tag ml-3', user.active ? 'tag-success' : 'tag-danger']">
          {{ user.active ? 'Активен' : 'Неактивен' }}
        </span>

        <b-button class="custom-btn-primary ml-auto" :disabled="loading" @click="onSubmit()">
          <b-spinner v-if="loading" small/>
          <v-icon name="buttons/check" :size="13"/>
          Сохранить
        </b-button>
      </div>
    </div>

    <div class="page-body" style="overflow-y: auto;">
      <b-skeleton-wrapper  :loading="isBusy">
        <template #loading>
          <b-tabs card>
            <b-tab disabled>
              <template #title>
                <v-icon name="navbar/user" :size="13" class="mr-2"/>
                <span>Учётные данные</span>
              </template>
            </b-tab>
            <b-tab disabled>
              <template #title>
                <v-icon name="navbar/user_cog" :size="13" class="mr-2"/>
                <span>Права доступа</span>
              </template>
            </b-tab>
            <b-tab disabled>
              <template #title>
                <v-icon name="navbar/link" :size="13" class="mr-2"/>
                <span>Связи</span>
              </template>
            </b-tab>
          </b-tabs>
          <b-row class="p-3">
            <b-col lg="6">
              <b-card class="custom-card">
                <b-row>
                  <b-col>
                    <b-skeleton width="29%" height="24%" class="mb-2"/>
                    <b-skeleton type="input" width="100%" height="45%"/>
                  </b-col>
                </b-row>
                <b-row class="mb-2">
                  <b-col>
                    <b-skeleton width="30%" height="24%" class="mb-2"/>
                    <b-skeleton type="input" width="100%" height="45%"/>
                  </b-col>
                </b-row>
                <b-row class="mb-2">
                  <b-col>
                    <b-skeleton width="30%" height="24%" class="mb-2"/>
                    <b-skeleton type="input" width="100%" height="45%"/>
                  </b-col>
                </b-row>
                <h5 class="my-2">Безопасность</h5>
                <b-row>
                  <b-col lg="6">
                    <b-card class="custom-card">
                      <b-row>
                        <b-col>
                          <b-skeleton type="input" width="45%" height="72%"/>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <b-skeleton width="9%" height="17%" class="mb-2"/>
                          <b-skeleton type="input" width="100%" height="31%" class="mb-2"/>
                          <b-skeleton width="86%" height="16%" class="mb-0"/>
                        </b-col>
                      </b-row>
                    </b-card>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
          </b-row>
        </template>

        <template #default>
          <b-tabs card class="custom-tabs">
            <b-tab active>
              <template #title>
                <v-icon name="navbar/user" :size="13" class="mr-2"/>
                <span>Учётные данные</span>
              </template>
              <b-row>
                <b-col lg="6">
                  <b-card class="custom-card">
                    <b-form-group
                      label="Имя пользователя"
                      :invalid-feedback="nameInvalidFeedback"
                      :state="nameState"
                    >
                      <b-form-input
                        type="text"
                        size="sm"
                        v-model="user.name"
                        :state="nameState"
                        trim>
                      </b-form-input>
                    </b-form-group>
                    <b-form-group
                      label="Email пользователя"
                      :invalid-feedback="emailInvalidFeedback"
                      :state="emailState"
                    >
                      <b-form-input
                        type="text"
                        size="sm"
                        v-model="user.email"
                        :state="emailState"
                        trim>
                      </b-form-input>
                    </b-form-group>
                    <b-form-group
                      label="Логин"
                      :invalid-feedback="userNameInvalidFeedback"
                      :state="userNameState"
                    >
                      <b-form-input
                        type="text"
                        size="sm"
                        v-model="user.username"
                        :state="userNameState"
                        trim>
                      </b-form-input>
                    </b-form-group>
                  </b-card>
                </b-col>
              </b-row>
              <h5 class="my-2">Безопасность</h5>
              <b-row>
                <b-col lg="6">
                  <b-card class="custom-card">
                    <div v-if="isEdit">
                      <b-button class="custom-btn-primary" @click.stop="onChangePassword">
                        <v-icon name="buttons/key" :size="13" class="mr-2"/>
                        Сбросить пароль
                      </b-button>
                      <b-button class="custom-btn-secondary ml-2" @click.stop="showCustomPassword = !showCustomPassword">
                        {{ showCustomPassword ? 'Отменить' : 'Указать свой пароль' }}
                      </b-button>
                      </div>

                    <b-form-group
                      v-if="!isEdit || showCustomPassword"
                      label="Пароль"
                      :description="!isEdit ? 'Придумайте пароль, используя латиницу и спецсимволы, минимум 12 символов. Будет использоваться для входа в систему.' : 'Придумайте пароль, используя латиницу и спецсимволы, минимум 12 символов. Будет применён после сохранения.'"
                      :invalid-feedback="passwordInvalidFeedback"
                      :state="passwordState"
                    >
                      <b-input-group>
                        <b-form-input
                          type="text"
                          v-model="password"
                          :state="passwordState"
                          trim
                        />
                        <b-input-group-append>
                          <b-button class="custom-btn-primary" @click.stop="onPasswordReset">
                            Сгенерировать новый
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>

                    <b-form-checkbox class="mt-2" v-model="user.active">
                      {{ user.active ? 'Пользователь активен' : 'Пользователь неактивен' }}
                    </b-form-checkbox>
                  </b-card>
                </b-col>
              </b-row>

            </b-tab>

            <b-tab>
              <template #title>
                <v-icon name="navbar/user_cog" :size="13" class="mr-2"/>
                <span>Права доступа</span>
              </template>
              <b-row>
                <b-col lg="6" md="12">
                  <b-card class="custom-card">
                    <b-form-group id="group-role" label="Роль">
                      <b-form-select
                        size="sm"
                        v-model="user.role"
                        @change="onSelectRole"
                      >
                        <option v-for="option in roles" :value="option.code">
                          {{ option.name }}
                        </option>
                      </b-form-select>
                    </b-form-group>

                    <p>Разрешения</p>
                    <b-list-group bg-variant="light" class="text-small">
                      <PermissionListItem v-for="(item, index) in treeData" :key="index" :item="item" :tree-data="treeData" :role-code="user.role"/>
                    </b-list-group>
                  </b-card>
                </b-col>
              </b-row>
            </b-tab>

            <b-tab>
              <template #title>
                <v-icon name="navbar/link" :size="13" class="mr-2"/>
                <span>Связи</span>
              </template>
              <b-row>
                <b-col lg="6" md="12">
                  <b-card class="custom-card">
                    <b-form-group label="Штатный сотрудник">
                      <div>
                        <staff-select ref="staff_select" @onSelect="updateStaffId"/>
                      </div>
                    </b-form-group>
                  </b-card>
                </b-col>
              </b-row>
            </b-tab>
          </b-tabs>
        </template>
      </b-skeleton-wrapper>
    </div>

    <b-modal ref="passwordModal" title="Новый пароль" hide-footer size="sm" centered>
      <b-form-text class="mb-2">Пароль успешно изменён. Сохраните его — показать его снова будет невозможно.</b-form-text>
      <b-input-group>
        <b-form-input type="text" readonly :value="generatedPassword"></b-form-input>
        <b-input-group-append>
          <b-button size="sm" variant="info" @click.stop="copyGeneratedPassword">Скопировать</b-button>
        </b-input-group-append>
      </b-input-group>
    </b-modal>
  </div>
</template>

<script>
import users from "../../network/users";
import roles from "../../network/roles";
  import helpers from "../../utilites/helpers";
  import dateFormatter from "../../utilites/dateFormatter";
    import UserRewards from "./UserRewards";
    import StaffSelect from "../Staff/StaffSelect";
    import PermissionListItem from "../Users/PermissionListItem"

const MIN_PASSWORD_LENGTH = 12;
const GENERATED_PASSWORD_LENGTH = 16;
const PASSWORD_CHARACTER_GROUPS = [
  'abcdefghijkmnopqrstuvwxyz',
  'ABCDEFGHJKLMNPQRSTUVWXYZ',
  '23456789',
  '!@#$%^&*_-+=?'
];

function secureRandomIndex(max) {
  const values = new Uint32Array(1);
  const range = 0x100000000;
  const limit = range - (range % max);

  do {
    window.crypto.getRandomValues(values);
  } while (values[0] >= limit);

  return values[0] % max;
}

function pickRandom(characters) {
  return characters[secureRandomIndex(characters.length)];
}

function generatePassword(length) {
  const allCharacters = PASSWORD_CHARACTER_GROUPS.join('');
  const password = PASSWORD_CHARACTER_GROUPS.map(pickRandom);

  while (password.length < length) {
    password.push(pickRandom(allCharacters));
  }

  for (let i = password.length - 1; i > 0; i--) {
    const j = secureRandomIndex(i + 1);
    [password[i], password[j]] = [password[j], password[i]];
  }

  return password.join('');
}

export default {
  components: { UserRewards, StaffSelect, PermissionListItem },
  mixins: [
    users, roles,
    dateFormatter, helpers
  ],
  name: "UserAdd",
  props: ['user_id'],
  data() {
    return {
      title: 'Профиль',
      apiUrl : 'users',
      isBusy: false,
      loading: false,
      user: {
        id: 0,
        username: '',
        password: '',
        name: '',
        email: '',
        role: 'manager',
        role_name: 'Менеджер',
        rate: 0,
        rate_tax: 0,
        active: true,
        staff_id: null,
        permissions: [],
      },
      isEdit: false,
      roles: [],
      password: '',
      generatedPassword: '',
      showCustomPassword: false,
      permissions: [],
      treeData: []
    }
  },
  async created() {
    await this.configureView(this.$props.user_id);
    this.roles = (await this. getUserRoles({})).data.items;
  },
  methods: {
    async configureView(user_id) {
      if (user_id) {
        await this.getUser(user_id);
        this.isEdit = true;
      } else {
        this.onPasswordReset();
      }

      await this.getPermissionsHandler();
    },
    async getUser(userId) {
      this.isBusy = true;
      this.loading = true;
      const result = await this.getUserById(userId);

      if (result && result.data) {
        this.isBusy = false;
        this.loading = false;
        this.user = result.data;

        this.$nextTick(async () => {
          if (this.$refs.staff_select && this.user.staff_id) {
            await this.$refs.staff_select.configure(this.user.staff_id);
          }
        });
      } else {
        this.isBusy = false;
        this.loading = false;
      }
    },
    async onSubmit() {
      this.loading = true;
      const isStaffValid = this.updateStaffId();

      if (!isStaffValid) {
        this.loading = false;
        return;
      }

      if (this.isEmpty(this.user.name)) {
        this.showSubmitError("Укажите имя пользователя.");
        this.loading = false;
        return;
      }

      if (this.isEmpty(this.user.username)) {
        this.showSubmitError("Укажите логин пользователя.");
        this.loading = false;
        return;
      }

      if (!this.validateEmail(this.user.email)) {
        this.showSubmitError("Укажите правильную почту пользователя.");
        this.loading = false;
        return;
      }

      this.updateUserPermissions();

      this.user.password = this.password
      const data = { ...this.user };

      const method = (data.id > 0) ? this.putUser : this.postUser;
      const result = await method(data);

      if (result.status === 422) {
        this.showSubmitError("Пользователь с таким логином уже существует. Найдите его в базе или введите другой логин.");
        this.loading = false;
        return;
      }

      if (!result || !result.data) {
        this.showError("Не удалось сохранить данные.");
        this.loading = false;
        return;
      }

      this.$router.push({
        name: 'Users',
        query: this.$route.query,
        hash: this.$route.hash
      }).catch(()=>{});

      this.loading = false;
    },
    onBack() {
      window.history.length > 1  ? this.$router.go(-1) : this.$router.push('/').catch(()=>{});
    },
    onPasswordReset() {
      this.password = generatePassword(GENERATED_PASSWORD_LENGTH);
    },
    async onChangePassword() {
      const isConfirmed = await this.showAcceptModal(
        'Сброс пароля',
        'Вы уверены, что хотите сбросить пароль пользователя?',
        'danger'
      );

      if (!isConfirmed) {
        return;
      }

      this.loading = true;
      const result = await this.postUserPassword({ id: this.user.id });
      this.loading = false;

      if (!result || !result.data || !result.data.password) {
        this.showError("Не удалось сбросить пароль.");
        return;
      }

      this.password = '';
      this.generatedPassword = result.data.password;
      this.$nextTick(() => {
        this.$refs.passwordModal.show();
      });
    },
    async copyGeneratedPassword() {
      try {
        await navigator.clipboard.writeText(this.generatedPassword);
        this.$bvToast.toast('Пароль скопирован в буфер обмена.', {
          title: 'Успешно',
          variant: 'success',
          autoHideDelay: 2000,
          solid: true
        });
      } catch (e) {
        this.showError("Не удалось скопировать пароль.");
      }
    },
    updateStaffId() {
      if (this.$refs.staff_select != null) {
        if (this.$refs.staff_select.item == null) {
          this.user.staff_id = null;
          return true;
        }

        const selectedStaff = this.$refs.staff_select.item;

        if (selectedStaff.user_id != null) {
          const isSelf = this.user.id > 0 && selectedStaff.user_id === this.user.id;

          if (!isSelf) {
            this.showError("Сотрудник уже связан с другим Пользователем.");
            this.user.staff_id = null;
            this.$refs.staff_select.onClear();
            return false;
          }
        }

        this.user.staff_id = selectedStaff.id;
        return true;
      }
    },
    getStaffVariant() {
      return this.user.staff_id != null ? 'success' : 'default';
    },
    // Permissions
    async getPermissionsHandler() {
      const result = await this.getPermissions();
      if (result.data != null) {
        this.permissions = result.data.items.map(function (item) {
          item._checked = this.user.permissions.some(perm => perm === item.code);
          return item;
        }.bind(this));
      } else {
        this.permissions = [];
      }

      this.treeData = this.arrayToTree(this.permissions);
    },
    updateUserPermissions() {
      const permArray = this.treeToArray(this.treeData);
      const filteredPerm = permArray.filter(perm => perm.checked || perm.indeterminate);
      this.user.permissions = filteredPerm.map(perm => perm.code);
    },
    arrayToTree(items, rootCode = null) {
      const lookup = {};
      items.forEach(item => {
        lookup[item.code] = {
          ...item,
          children: [],
          _selected: item._checked,
          _computedChecked: false,
          _computedIndeterminate: false
        };
      });

      const tree = [];
      items.forEach(item => {
        if (item.parent_code === rootCode) {
          tree.push(lookup[item.code]);
        } else {
          const parent = lookup[item.parent_code];
          if (parent) {
            parent.children.push(lookup[item.code]);
          }
        }
      });

      // Фаза 3: Рекурсивный расчет снизу вверх
      const computeNodeState = (node) => {
        if (!node.children || node.children.length === 0) {
          // Лист
          if (node._selected) {
            node._computedChecked = true;
            node._computedIndeterminate = false;
          } else {
            node._computedChecked = false;
            node._computedIndeterminate = false;
          }
          return { checked: node._computedChecked, indeterminate: node._computedIndeterminate };
        }

        // Обрабатываем детей
        let childCheckedCount = 0;
        let childIndeterminateCount = 0;

        node.children.forEach(child => {
          const state = computeNodeState(child);
          if (state.checked) childCheckedCount++;
          if (state.indeterminate) childIndeterminateCount++;
        });

        const allChildrenChecked = childCheckedCount === node.children.length;
        const someChildrenSelected = childCheckedCount > 0 || childIndeterminateCount > 0;

        // Правила определения состояния:
        // 1. Если узел в selectedSet, он должен быть либо checked, либо indeterminate
        // 2. Если все дети checked, узел должен быть checked
        // 3. Если некоторые дети selected (checked или indeterminate), узел должен быть indeterminate
        // 4. Иначе узел не выбран

        if (node._selected) {
          // Узел явно в selectedCodes
          if (allChildrenChecked) {
            node._computedChecked = true;
            node._computedIndeterminate = false;
          } else {
            // Если не все дети выбраны, но узел в selectedCodes,
            // значит он должен быть indeterminate
            node._computedChecked = false;
            node._computedIndeterminate = true;
          }
        } else {
          // Узел не в selectedCodes
          if (allChildrenChecked) {
            node._computedChecked = true;
            node._computedIndeterminate = false;
          } else if (someChildrenSelected) {
            node._computedChecked = false;
            node._computedIndeterminate = true;
          } else {
            node._computedChecked = false;
            node._computedIndeterminate = false;
          }
        }

        return {
          checked: node._computedChecked,
          indeterminate: node._computedIndeterminate
        };
      };

      // Фаза 4: Применение вычисленных состояний
      const applyComputedStates = (node) => {
        node.checked = node._computedChecked;
        node.indeterminate = node._computedIndeterminate;

        delete node._selected;
        delete node._computedChecked;
        delete node._computedIndeterminate;

        if (node.children && node.children.length > 0) {
          node.children.forEach(child => applyComputedStates(child));
        }
      };

      // Выполняем расчеты
      tree.forEach(root => computeNodeState(root));
      tree.forEach(root => applyComputedStates(root));

      return tree;
    },
    // Функция преобразования дерева в массив
    treeToArray(nodes, parentCode = null) {
      const result = [];

      nodes.forEach(node => {
        result.push({
          code: node.code,
          name: node.name,
          parent_code: parentCode,
          checked: node.checked,
          indeterminate: node.indeterminate
        });

        if (node.children && node.children.length > 0) {
          result.push(...this.treeToArray(node.children, node.code));
        }
      });

      return result;
    },
    async onSelectRole(v) {
      const findRole = this.roles.find(r => r.code === v);

      if (!findRole) return;

      const result = await this.getUserRoleById(findRole.id);

      if (!result || !result.data) return;

      const role = result.data;
      this.user.permissions = role.permissions;
      await this.getPermissionsHandler();
    }
  },
  computed: {
    nameState() {
      return this.user.name.length >= 6;
    },
    nameInvalidFeedback() {
      return 'Минимум 6 символов.';
    },
    emailState() {
      return this.user.email.length >= 6;
    },
    emailInvalidFeedback() {
      return 'Минимум 6 символов.';
    },
    userNameState() {
      return this.user.username.length >= 5;
    },
    userNameInvalidFeedback() {
      return 'Минимум 5 символов.';
    },
    passwordState() {
      return this.password.length >= MIN_PASSWORD_LENGTH
    },
    passwordInvalidFeedback() {
      return `Минимум ${MIN_PASSWORD_LENGTH} символов.`;
    },
  },
}
</script>

<style>
#user-ellipsis-loading {
  white-space: nowrap;
  display: inline-block;
}

@keyframes blink {
  0% { content: "."; }
  33% { content: ".."; }
  66% { content: "..."; }
  100% { content: "."; }
}

#user-ellipsis-loading::after {
  content: ".";
  animation: blink 1.5s infinite step-start;
}
</style>



// WEBPACK FOOTER //
// src/components/Users/User.vue